import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "@mantine/core";
import { ChatMessages } from "./ChatMessages.js";
import { useRef } from "react";
import { ChatInputWrapper } from "./ChatInputWrapper.js";
import { useChatOpen } from "../../hooks/assistant.js";
export const Chat = () => {
    const inputWrapperRef = useRef(null);
    const inputRef = useRef(null);
    const chatOpen = useChatOpen();
    /**
     * We want to keep chat processing even if the chat is closed
     */
    const display = chatOpen ? "flex" : "none";
    return (_jsxs(Flex, { flex: "3 1 400px", miw: 0, direction: "column", pos: "relative", m: "sm", bg: "light-dark(white, black)", display: display, children: [_jsx(ChatMessages, { inputWrapperRef: inputWrapperRef, inputRef: inputRef }), _jsx(ChatInputWrapper, { inputWrapperRef: inputWrapperRef, inputRef: inputRef })] }));
};
